<template>
    <div class="sidebar-user-menu inline-flex flex-col px-5 py-base-7 bg-sidebar text-main-color max-w-[260px] sm:max-w-[285px] w-full overflow-auto lg:sticky top-0 start-0 bottom-0 lg:h-screen lg:self-start dark:bg-slate-800 dark:text-white" :class="{'show': isOpenSidebar}">
        <BaseIcon name="arrow_left" class="absolute top-8 end-5 rtl:rotate-180 block sm:hidden" @click="setIsOpenSidebar(false)" />
        <div class="mb-6 flex items-center gap-2">
            <Logo class="w-max" :className="'max-w-[140px]'" />
        </div>
        <div class="sidebar-user-menu-box bg-light-gray border border-light-web-wash p-base-2 rounded-lg dark:bg-dark-web-wash dark:border-white/10">
            <div class="flex items-center gap-3">
                <Avatar :user="user" :activePopover="false" :size="56"/>
                <div class="flex-1 min-w-0">
                    <UserName :user="user" :activePopover="false" class="sidebar-user-menu-name" />
                    <router-link :to="{name: 'profile', params: {user_name: user.user_name}}" class="sidebar-user-menu-sub-text inline-block text-xs text-sub-color dark:text-slate-400 truncate">{{mentionChar + user.user_name}}</router-link>  
                    <div v-if="config.wallet.enable" class="text-xs"><router-link :to="{name: 'wallet'}" class="sidebar-user-menu-link">{{ exchangeTokenCurrency(user.wallet_balance) }}</router-link></div>
                    <a v-if="user.is_moderator" :href="user.admin_link" target="_blank" class="sidebar-user-menu-link text-xs">{{$t('Go to admin panel')}}</a>
                </div>
                <div>
                    <PageSwitchItem v-if="user.is_page" :page="user.parent" @click="handleClickLoginBack()" class="sidebar-user-menu-icon pulser switch-page-icon"/>
                    <button v-else @click="handleSwitchPage()">
                        <BaseIcon name="user_switch" size="32" class="sidebar-user-menu-icon"/>
                    </button>
                </div>
            </div>
            <div v-if="config.membership.enable && !user.is_moderator" class="mt-2">
                <div class="font-semibold mb-1">{{ user.membership_package_name ? $t('Current Package') + ': ' + user.membership_package_name : $t('Current Package: Free') }}</div>
                <BaseButton :to="{name: 'membership'}" size="sm">{{ $t('Upgrade Membership') }}</BaseButton>
            </div>
        </div>
        <div class="sidebar-main-menu flex-1 pt-3 pb-5">
            <SidebarMenu />
            <div class="mt-5 hidden lg:block">
                <BaseButton @click="openStatusBox()" fluid>{{$t('Add New Post')}}</BaseButton>
            </div>
            <div class="mt-4 hidden lg:flex flex-col items-center gap-0 text-[0] leading-none space-y-0">
                <button @click="handleClickStore('apple')" aria-label="Apple" class="block m-0 p-0 rounded hover:bg-light-gray dark:hover:bg-dark-web-wash h-[30px] xl:h-10 2xl:h-12 w-auto overflow-hidden">
                    <img :src="storeSrc('apple')" alt="Apple" class="block m-0 w-full h-full object-contain"/>
                </button>
                <button @click="handleClickStore('google')" aria-label="Google" class="block m-0 p-0 rounded hover:bg-light-gray dark:hover:bg-dark-web-wash h-[30px] xl:h-10 2xl:h-12 w-auto overflow-hidden">
                    <img :src="storeSrc('google')" alt="Google" class="block m-0 w-full h-full object-contain"/>
                </button>
                <button @click="handleClickStore('huawei')" aria-label="Huawei" class="block m-0 p-0 rounded hover:bg-light-gray dark:hover:bg-dark-web-wash h-[30px] xl:h-10 2xl:h-12 w-auto overflow-hidden">
                    <img :src="storeSrc('huawei')" alt="Huawei" class="block m-0 w-full h-full object-contain"/>
                </button>
            </div>
        </div>
        <FooterSite class="border-t border-divider"/>
    </div>
</template>

<script>
import { mapState, mapActions} from 'pinia'
import { useAuthStore } from '@/store/auth'
import { useAppStore } from '@/store/app'
import { useUtilitiesStore } from '@/store/utilities'
import { loginBack } from '@/api/page'
import Constant from '@/utility/constant'
import FooterSite from '@/components/layout/FooterSite.vue'
import BaseButton from '@/components/inputs/BaseButton.vue'
import Avatar from '@/components/user/Avatar.vue'
import UserName from '@/components/user/UserName.vue'
import Logo from '@/components/utilities/Logo.vue'
import BaseIcon from '@/components/icons/BaseIcon.vue'
import SwitchPagesModal from '@/components/modals/SwitchPagesModal.vue'
import PageSwitchItem from '@/components/user_page/PageSwitchItem.vue';
import SidebarMenu from '@/components/sidebar/index.vue'

export default {
    components: {
        BaseButton,
        FooterSite,
        UserName,
        Logo,
        BaseIcon,
        Avatar,
        PageSwitchItem,
        SidebarMenu
    },
    data(){
        return{
            mentionChar: Constant.MENTION
        }
    },
    computed:{
        ...mapState(useAuthStore, ['user']),
        ...mapState(useAppStore, ['config', 'isOpenSidebar', 'menus'])
    },
    methods: {
        ...mapActions(useUtilitiesStore, ['setSelectedPage']),
        ...mapActions(useAppStore, ['setIsOpenSidebar']),
        openStatusBox(){
			this.showPostStatusBox()
		},
        storeSrc(platform){
            return `/images/mobile/${platform}.png`
        },
        async handleClickStore(platform){
            try{
                const { default: BasicModal } = await import('@/components/modals/BasicModal.vue')
                this.$dialog.open(BasicModal, {
                    props:{
                        header: this.$t('Investments Mobile'),
                        modal: true,
                        dismissableMask: true,
                        draggable: false
                    },
                    data:{
                        content: 'Aplicatiile mobile sunt in constructie'
                    }
                })
                const params = { platform, position: 'sidebar' }
                if (window.gtag) {
                    window.gtag('event', 'download_app_attempt', params)
                } else if (window.dataLayer) {
                    window.dataLayer.push({ event: 'download_app_attempt', ...params })
                }
            }catch(e){ console.warn(e) }
        },
        handleSwitchPage(){
            this.$dialog.open(SwitchPagesModal, {
                props:{
					header: this.$t('Switch Page'),
                    modal: true,
                    dismissableMask: true,
                    draggable: false
                }
            });
        },
        handleClickLoginBack(){
            try {
                this.setSelectedPage(this.user.parent)
                setTimeout(async() => {
                    await loginBack()
                    window.location.href = this.user.parent.href
                }, 1500);
            } catch (error) {
                this.showError(error.error)
            }
        }
    }
}
</script>
